import React, { useState, useRef, useEffect } from "react";
import { Document, pdfjs } from "react-pdf";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import { PdfViewer } from "react-pdf-selection";
import { Tooltip, Zoom, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "../../assets/css/TextLayer.css";
import { motion } from "framer-motion";
import ContentLoader from "../content-loader";
// import pdfview from '../../assets/images/Company-Overview.pdf';
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.js",
  import.meta.url
).toString();
const LibraryReactPdf = (props) => {
  const [numPages, setNumPages] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const [inputPageNumber, setInputPageNumber] = useState(1);
  const [anchorEl3, setAnchorEl3] = useState(null);
  const [searchText, setSearchText] = useState("");
  const pdfContainerRef = useRef(null);
  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };
  const handlePageChange = (e) => {
    const value = parseInt(e.target.value);
    setInputPageNumber(value);
    if (value >= 1 && value <= numPages) {
      setPageNumber(value);
    }
  };
  const handleScroll = () => {
    if (!pdfContainerRef.current) return;
    const { scrollTop, clientHeight, scrollHeight } = pdfContainerRef.current;
    const totalPagesVisible =
      numPages - Math.ceil(scrollHeight / clientHeight) + 1;
    const currentPage =
      Math.ceil((scrollTop / clientHeight) * totalPagesVisible) + 1;
    setPageNumber(currentPage);
    setInputPageNumber(currentPage);
  };
  const scrollToPage = (page) => {
    if (!pdfContainerRef.current) return;
    const { clientHeight } = pdfContainerRef.current;
    const scrollTo = (page - 1) * clientHeight;
    pdfContainerRef.current.scrollTo({ top: scrollTo, behavior: "smooth" });
  };
  const handleClosePdf = () => {
    props.closeDrawer();
  };

  const [viewerKey, setViewerKey] = useState(0); // reset the viewer key to re-render the docviewer
  const [docs, setDocs] = useState([]); // set the docs to be rendered in the docviewer
  const [isPdfSelected, setIsPdfSelected] = useState(false); 

  useEffect(() => {
    setViewerKey((prevKey) => prevKey + 1);
  },[docs])

  useEffect(() => {
    if(props.activePdf)
    {
      const fileName = props?.file_name;
      const fileParts = fileName.split('.');
      const fileExtension = fileParts[fileParts.length - 1];
      setIsPdfSelected(fileExtension === 'pdf');
      if(fileExtension !== 'pdf')
      {
        setDocs([{uri: props?.file_path, fileType: fileExtension, fileName: props?.file_name}]);
      }
      else if(fileExtension === 'pdf')
      {
        setDocs([]);
      }
    }
  },[props.activePdf])

  return (
    <div className="pdfView_wrapper">
      <div className="pdfView_head">
        <div className="pdf_title">
          <h2>{props.file_name}</h2>
        </div>
        <div className="viewer-actions library_pdf_close">
          <Tooltip
            className="blue-tooltip"
            title="Close Pdf"
            TransitionComponent={Zoom}
            placement="top"
            arrow
          >
            <IconButton className=" ">
              <CloseIcon onClick={handleClosePdf} />
            </IconButton>
          </Tooltip>
        </div>
      </div>
      {isPdfSelected && props?.activePdf &&
      <div className="pdfView_body">
        <motion.div
          className="pdf_scroller"
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{
            duration: 0.8,
            delay: 0.5,
            ease: [0, 0.71, 0.2, 1.01],
          }}
          onScroll={handleScroll}
          ref={pdfContainerRef}
        >
          <Document
                file={props.file_path}
                onLoadSuccess={onDocumentLoadSuccess}
                renderMode="none"
              />
              <PdfViewer
                url={props.file_path}
                onTextSelection={(selection) => setSearchText(selection?.text)}
                loading={<ContentLoader />}
              />
        </motion.div>
      </div>}
      {isPdfSelected === false && props?.activePdf && 
      <div className="pdfView_body">
        
          <DocViewer 
               
               key={viewerKey}
               documents={docs}
               pluginRenderers={DocViewerRenderers}
                 />
        
      </div>}
      {/* <div className='pdfView_foot'>
    
         <div  className='librarycircle'    >
            <Tooltip className="blue-tooltip" title="Start Chat" TransitionComponent={Zoom} placement="top" arrow>
               <Link to="#" className='librarychatbtn'>
               <QuestionAnswerOutlinedIcon />
               </Link>
            </Tooltip>
         </div>
      </div> */}
    </div>
  );
};
export default LibraryReactPdf;
